

module.exports = {

	methods: {

		rememberArticle(key, id){

		},

		unRememberArticle(key, id){

		
		},

	}

};



// WEBPACK FOOTER //
// ./client/mixins/rememberArticles.js